<template>
	<section class="subscribeProduct">
		<Nav title="订阅产品" />
		<section class="full_box">
			<div class="full_num">
				<h4>请选择订阅版本</h4>
				<h3>该订阅仅为支付软件费用，并非广告投放充值</h3>
				<div class="list">
					<div class="item" @click="chooseNum(i)" :class="{active: activeIndex==i}" v-for="(item,i) in numList" :key="item.id">
						<span>{{item.subscriptionVersion | f_subscriptionVersion}}</span>
					</div>
				</div>
			</div>
            <div class="product_details">
                <p>
                    <span class="label">团队配额</span>
                    <span class="info">{{numList[activeIndex].teamQuota || '无配额'}}</span>
                </p>
                <p>
                    <span class="label">团队管理员配额</span>
                    <span class="info">{{numList[activeIndex].teamAdminQuota || '无配额'}}</span>
                </p>
                <p>
                    <span class="label">业务员配额</span>
                    <span class="info">{{numList[activeIndex].salesmanQuota}}</span>
                </p>
                <p>
                    <span class="label">在投计划数配额</span>
                    <span class="info">{{numList[activeIndex].investmentPlanQuota}}</span>
                </p>
                <p v-show="false">
                    <span class="label">私有客户数配额</span>
                    <span class="info">{{numList[activeIndex].privateCustomerQuota}}</span>
                </p>
                <p>
                    <span class="label">订阅价格</span>
                    <span class="info">{{numList[activeIndex].subscriptionPrice | f_currency}}</span>
                </p>
                <p>
                    <span class="label">首订折扣</span>
                    <span class="info">{{numList[activeIndex].firstOrderDiscount*10}}折（首订享受，支付时自动优惠）</span>
                </p>
                <p>
                    <span class="label">首订折后价格</span>
                    <span class="info">{{numList[activeIndex].subscriptionPrice * numList[activeIndex].firstOrderDiscount | f_currency}}</span>
                </p>
                <p>
                    <span class="label">订阅周期</span>
                    <span class="info">{{numList[activeIndex].subscriptionDurationDays}}天</span>
                </p>
                <p>
                    <span class="label">委托推广</span>
                    <span class="info" v-if="numList[activeIndex].subscriptionVersion == 1">签约后可本省获客</span>
                    <span class="info" v-if="numList[activeIndex].subscriptionVersion == 2">签约后可全国获客</span>
                    <span class="info" v-if="numList[activeIndex].subscriptionVersion == 3">签约后可全国获客，可定制投放渠道和需求</span>
                </p>
                <p>
                    <span class="label">备注</span>
                    <span class="info">{{numList[activeIndex].remark}}</span>
                </p>
            </div>          
			<div class="zhifu">
				<p class="tit">请选择支付方式</p>
				<van-cell :title="item.cashierTypeName" :icon="item.icon" v-for="item in typeList" :key="item.id">
					<template #right-icon>
						<div v-if="cashierTypeId==item.id">
							<img src="../../assets/img/check_a.png" class="check" @click="checkFn(item.id)">
						</div>
						<div v-else>
							<img src="../../assets/img/check.png" class="check" @click="checkFn(item.id)">
						</div>
					</template>
				</van-cell>
			</div>
            <section class="tips_area">
                <h3>三个版本主要区别</h3>
                <ol>
                    <li>团队结构不同：入门版和专业版都是“管理员”→“业务员”两层。旗舰版是“管理员”→“团队”→“业务员”三层。</li>
                    <li>业务员账号（子账号）数量不同：入门版2个，专业版10个，旗舰版50个。</li>
                    <li>获客范围不同：入门版只能本省获客，专业版和旗舰版均可全国获客。</li>
                    <li>同时投放的计划数量：入门版3个，专业版10个，旗舰版100个。但累计投放的计划数均没有限制。</li>
                </ol>
            </section>
			<div class="bottom_btn">
                <van-button type="danger" class="danger-button" @click="payFn">立即订阅</van-button>
			</div>
		</section>
	</section>
</template>

<script>
import settingServer from "api/setting";

import Nav from "components/Nav";
import { Notify } from 'vant';


export default {
	components: {
		Nav,
	},
	data() {
		return {
			numInit: 100,
			numList: [],
			price: '',
			skuId: '',
			activeIndex:0,
			activeNames: [0],
			isCheck: 1,
			clientType: this.$store.state.clientType,  //客户端类型 1-iOS 2-安卓 3-h5	
			params: {
				orderId: '',
				amount: '',
			},
			cashierTypeId: '',
			typeList: [],
            cashierTypeCode: '',
		}
	},
	created() {
		this.params.orderId = this.$route.params.id
		this.activeIndex = this.$route.query.index||0
		this.getNumList()
		this.getPayList()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getPayList () {
			settingServer.getCashierTypeList().then((res) => {
				this.typeList = res.data;
                // 默认选中第一个
				this.cashierTypeId = this.typeList[0].id
                this.cashierTypeCode = this.typeList[0].code
			})
		},

		getNumList() {
			settingServer.getSubscribeProductPageList({ pageNum:1, pageSize:100 }).then((res) => {
				this.numList = res.data.list.reverse()
				this.price = this.numList[this.activeIndex].subscriptionPrice
				this.skuId = this.numList[this.activeIndex].id
				if(this.tickeId) {
					this.getTicketInfo()
				}else {

				}
			})
		},

		chooseNum(i) {
			this.activeIndex = i
			this.price = this.numList[i].subscriptionPrice
			this.skuId = this.numList[i].id
		},

		checkFn(id) {
			this.cashierTypeId = id
            this.cashierTypeCode = this.typeList[id].code
		},

		payFn() {
            this.requestPay()
		},

		requestPay() {
			if(!this.isCheck) return Notify({ type: 'danger', message: '请选择支付方式' })

            settingServer.submitSubscribeOrder({id: this.skuId, paymentChannel: 7}).then((res) => {
                localStorage.setItem("rechargeStatus", 0)
                this.$router.push({name: 'payview', params:{orderNo:res.data, cashierTypeCode:this.cashierTypeCode, cashierTypeId:this.cashierTypeId }})
            })
		},
	}
}
</script>

<style lang="scss">
	.subscribeProduct {
		padding-top: 46px;
        padding-bottom: 90px;
		color: #2B2F3A;
		.full_num {
			padding: 20px;
			padding-bottom: 0;
			padding-right: 0;
			background: #fff;
			h4 {
				font-size: 15px;
				padding-bottom: 8px;
			}
			h3 {
				font-size: 13px;
				padding-bottom: 10px;
				color: red;
			}			
			p {
				font-size: 16px;
				padding-top: 7px;
				padding-bottom: 20px;

			}
			.list {
				display: flex;
				flex-wrap: wrap;
				.item {
					position: relative;
					width: 102px;
					height: 71px;
					font-size: 16px;
					line-height: 71px;
					border-radius: 4px;
					background: #fff;
					text-align: center;
					margin-bottom: 16px;
					margin-right: 13px;
					border: 1px solid #7E92E2;
					color: #3A5EEC;
					span {
						position: relative;
						z-index: 2;
					}
					img {
						position: absolute;
						bottom: 0;
						right: 0;
						width: 83px;
						z-index: 1;
					}
				}
				.active {
					background: #3A5EEC;
					color: #fff;
					font-weight: bold;

				}
			}
		}

        .product_details {
            background-color: #fff;
            padding: 12px 20px;
            margin: 6px 0 10px 0;

            p {
                display: flex;
                justify-content: space-between;
                font-size: 13px;
                line-height: 1.8;
            }
        }

		.zhifu {
			background: #fff;
			.tit {
				color: #7D8290;
				font-size: 14px;
				padding: 12px 20px;
			}
			.van-cell {
				// height: 50px;
				align-items: center;
				padding: 10px 21px;
				display: flex;
				align-items: center;
			}
			.van-cell__title {
				font-size: 15px;
				color: #2B2F3A;
			}
			.van-icon__image, .check {
				width: 22px;
				height: 22px;
			}
			.van-cell__left-icon, .van-cell__right-icon {
				height: 22px;
				width: 22px;
			}
			.van-collapse {
				border-top: 1Px solid #F6F6F6;
				.van-cell__right-icon {
					color: #7D8290;
				}
				span {
					color: #7D8290;
					font-size: 14px;

				}
				.van-icon {
					color: #CCCED4;
					font-size: 18px;
				}
			}
			.van-collapse-item__title--expanded::after, .van-cell::after {
				display: none;
			}
			.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
				border: 0;
				// border-top: 1Px solid #f6f6f6;
			}
			.van-collapse-item__content {
				color: #7D8290;
				font-size: 14px;
				p {
					padding-bottom: 8px;
				}
			}
			
		}

		.bottom_btn {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			display: flex;
			align-items: center;
			height: 56px;

            .danger-button {
                width: 100%;
                height: 56px;
                font-size: 17px;
                font-weight: bold;
                border: 0;
            }
		}


        .tips_area {
            // border-radius: 24px;
            background: #FDFDFD;
            padding: 0 0 18px 16px;

            h3 {
                color: #4D5B80;
                font-size: 14px;
                line-height: 30px;
                font-weight: 450;
                font-style: normal;
                padding-top: 4px;
                margin-top: 10px;
                border-bottom: 1px dotted #E9F0F8;
            }

            ol {
                margin-left: 18px;
                margin-right: 20px;
                list-style-type: decimal;

                li {
                    color: #4D5B80;
                    font-size: 13px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px;
                    margin-bottom: 4px;
                }
            }
        }        
	}
</style>


// WEBPACK FOOTER //
// src/views/subscribe/Product.vue